import axios from "axios";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardYear from "../components/Gas/CardYear";
import ListaYear from "../components/Gas/ListaYear";
import SecondaryMenuGas from "../components/Gas/SecondaryMenuGas";
import { setConsumi, setInfo } from "../features/gasSlice";
import { setSection } from "../features/settingSlice";
import "../style/Gas/Consumi.scss";
import SubHeader from "../components/SubHeader";
import { setCurrentPod } from "../features/userSlice";
import NewHeader from "../components/New Header/NewHeader";
import "./Consumi/_consumi.scss";
import Header from '../components/Header in Page/_Header';
import ViewGas from "../components/Consumi Gas/ViewYear/ViewGas";

function AreaGas() {
 

  

  return (
    <div className="consumi gas">
      <div className="consumi-top">
        <NewHeader logo='white' padding='no' iconsColor='white'/>
      </div>
      <div className="consumi-bottom">
        <Header
          title="Consumi"
          description={`Qui verranno riportati i tuoi dati. Tieni sotto controllo le tue utenze e scopri i tuoi consumi.`}
          icon="consumi"
        />
        <ViewGas />
        <div className="empty" style={{height: '100px'}}></div>
      </div>
    </div>
  );
}

export default AreaGas;
